export const graphqlBaseUrlTest = process.env.REACT_APP_BACKEND_URL_TEST;
export const graphqlBaseUrlLive = process.env.REACT_APP_BACKEND_URL_LIVE;
export const projectName = process.env.REACT_APP_PROJECT_NAME;
